import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import TillForm from './forms/TillForm';
import TillList from './lists/TillList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import ModalEditor from "./ModalEditor";
import TillRepositoryEditor from "./TillRepositoryEditor";

class TillEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return (
            <Fragment>
                <List
                    {...this.props}
                    theme="default"
                    header={"Kasszák"}
                    footer={[
                        <Button key="0" color="default" disabled={this.props.isLoading} onClick={ this.pristineForm }>
                            Új
                        </Button>
                    ]}
                >
                    <TillList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={"Kassza"}
                    footer={[
                        <Button key="0" disabled={ !this.props.dirty || this.props.isLoading } color="primary" className="pull-right" onClick={ this.saveForm }>
                            Mentés
                        </Button>
                    ]}
                >
                    <TillForm {...this.props} />
                </Editor>
                {
                    this.props.values[this.props.componentConfig.idfield] &&
                    <TillRepositoryEditor
                        gridid={"TillEditorTillRepositoryList"}
                        presets={{till: this.props.values[this.props.componentConfig.idfield]}}
                        isLoading={this.props.isLoading}
                        editor={ModalEditor}
                        selection={null}
                        filter={[
                            {
                            field: "till",
                            value: this.props.values[this.props.componentConfig.idfield]
                            }
                        ]}
                    />
                }
            </Fragment>
        );
    }
}

export default createEditor({componentName: "Till", WrappedComponent: TillEditor});
